import PropTypes from 'prop-types';
import React from 'react';

export const UnitIndicator = ({ color, height, width, margin }) => {
  return (
    <svg height={height} width={width} style={{ margin }}>
      <circle fill={color} cx={width / 2} cy={height / 2} r={width / 2} />
    </svg>
  );
};

UnitIndicator.propTypes = {
  color: PropTypes.any,
  height: PropTypes.number,
  margin: PropTypes.any,
  width: PropTypes.number,
};
